var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"card success-message-card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_vm._v("\n           Cập nhật thành công!\n          ")])],1)],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('span',[_vm._v("Điểm đến")]),_c('div',{staticClass:"card-header-actions"})])
}]

export { render, staticRenderFns }